import { getLocale, isLocale, setLocale } from "@nerves/i18n/runtime";
import { useSyncExternalStore } from "react";

export type Locale = "en" | "de";

const listeners = new Set<() => void>();
let version = 0;

/** Language names are shown in their own language. */
export const LOCALES: ReadonlyArray<{ value: Locale; label: string }> = [
  { value: "en", label: "English" },
  { value: "de", label: "Deutsch" },
];

function syncDocument() {
  document.documentElement.setAttribute("lang", getLocale());
}

/** Switches the UI language live (no reload). */
export function applyLocale(next: string) {
  if (!isLocale(next) || next === getLocale()) return;
  void setLocale(next, { reload: false });
  syncDocument();
  version++;
  for (const l of listeners) l();
}

/** Before the first render: an existing cookie wins, else the browser language. */
export function initLocale() {
  const hasCookie = document.cookie.split("; ").some((c) => c.startsWith("PARAGLIDE_LOCALE="));
  if (!hasCookie) {
    const guess = (navigator.language || "en").slice(0, 2);
    if (isLocale(guess)) void setLocale(guess, { reload: false });
  }
  syncDocument();
}

export function useLocale(): Locale {
  useSyncExternalStore(
    (l) => {
      listeners.add(l);
      return () => {
        listeners.delete(l);
      };
    },
    () => version,
  );
  return getLocale() as Locale;
}
